<template>
    <Wrapper>
        <div class="row flex-grow-1">
            <div class="col">
                <h4 class="mb-3 font-weight-light">Frequently Asked Questions</h4>
                <div class="row">
                    <div class="col-12 mx-auto">
                        <div class="accordion" id="faqExample">
                            <div class="card">
                                <div class="card-header bg-transparent p-2" id="headingOne">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link stretched-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Q: How does this work? What is this FAQ page for?
                                        </button>
                                     </h5>
                                </div>
            
                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#faqExample">
                                    <div class="card-body">
                                        <p class="font-weight-bold">Answer:</p>
                                        <p>
                                            It works using the Bootstrap 4 collapse component with cards to make a vertical accordion that expands and collapses as questions are toggled.
                                            This can be used as a template to create a page that shows Frequently Asked Questions, and grouped Q & A.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header bg-transparent p-2" id="headingTwo">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link stretched-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                          Q: What is Bootstrap 4?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#faqExample">
                                    <div class="card-body">
                                        <p>Bootstrap is the most popular CSS framework in the world. The latest version released in 2018 is Bootstrap 4. Bootstrap can be used to quickly build responsive websites.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header bg-transparent p-2" id="headingThree">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link stretched-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                          Q. What is another question?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#faqExample">
                                    <div class="card-body">
                                        <p>The answer to the question can go here.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header bg-transparent p-2" id="headingFour">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link stretched-link collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                          Q. What is the next question?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#faqExample">
                                    <div class="card-body">
                                        <p>The answer to this question can go here. This FAQ example can contain all the Q/A that is needed. These are static text examples but they could also be generateed dyanmically from data.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper } from '../components';

export default {
    components: {
        Wrapper
    }
}
</script>
